import React from 'react';
import "../template-file-css/document-file-template.css";


export const RFS_RiseInitialClientIntakePacket = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='RFS_RiseInitialClientIntakePacket' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><center><h3><b>Client Orientation Snapshot</b></h3></center>
                    <b>Mission Statement:</b>Our mission is to promote personal growth and community integration for individuals with
                    behavioral health needs through evidence-based practices. <br /> <br />
                    <b>Office Information: R.I.S.E Family Services 9811 Mallard Drive -Suite #203 Laurel, Maryland 20708</b>Administrative Office
                    Hours of Operation: Monday- Friday 9:00 AM-8:00 PM Saturday 12:00 PM - 5:00 PM  <br /><br />
                    <b>Access to after Hour Services:</b>If you need emergency mental health assistance at any point outside of business hours
                    please call: R.I.S.E family Services 301-778-8835 Press 0</p>

                <ul>
                    <li>911 (for life-threatening emergencies)</li>
                    <li>Mobile Crisis (MD Relay Dial 711)</li>
                    <li>UM Laurel Medical Center (301) 725-4300</li>
                    <li>PG County Community Crisis Response System (301) 429-2185</li>
                    <li>PG Community Crisis Hotline (1) 800-422-0009</li>
                    <li>House of Ruth Maryland (Domestic Abuse) (202) 481-1440</li>
                </ul>

                <p className='w-750'><b>Confidentiality & HIPPA: </b>Information you share with R.I.S.E Family Services is confidential and may only be released
                    with your consent, with a few exceptions:</p>
                <li>Department of Health and Mental Hygiene for oversight of care;</li>
                <li>HHS Office of Civil Rights to determine compliance with privacy rules;</li>
                <li>Report of child abuse or neglect that occurred at any time;</li>
                <li>An imminent threat to yourself and/or others; and, court order.</li>

                <p className='w-750'>
                    We do not give out, exchange, barter, rent, sell, lend, or disseminate any information about applicants or clients who apply for or receive
                    our services that is considered patient confidential, is restricted by law, or has been specifically restricted by a patient/client in a signed
                    HIPAA consent form. <br /><br />

                    <b> Your Rights and Responsibilities:</b>You have the right, prior to admission, to an explanation of your individual right in terms and
                    language that is understood. R.I.S.E Family Services is here to help and should not cause you any harm, emotional, financial or
                    otherwise. You have a right to view a full list of the Individual Rights as posted in a prominent place at the R.I.S.E Family Services
                    facility and on our website at  <a href="www.rise-family.org.">www.rise-family.org.</a>
                    <br /><br />

                    <b>Discharge:</b>R.I.S.E Family Services, LLC strives to provide its services to ensure that the client will receive optimal results in the
                    therapeutic process. Termination or discharge from R.I.S.E Family Services is the goal upon initial services as the client begins to
                    master set tasks and reach outlined-goals. R.I.S.E reserves the right to terminate or discharge a client based on, but not limited to criteria
                    outlined in the discharge policy that you received during this orientation. <br /><br />

                    <b>Grievances & Complaints:</b> Any client wishing to file a grievance may do so. When a client files a complaint, there shall be no
                    retaliation or barriers to service. To start the grievance process, the client shall fill out a Grievance Form. If a client needs help filling out
                    a Grievance Form, an uninvolved employee shall help the client. The Grievance Form is given to the Program Director (PD). If the
                    grievance or appeal is regarding the PD, the grievance or appeal shall be filed with the owner ofR.I.S.E Family Services. The numbers
                    below can assist you with complaints, as well. <br /><br />

                    <b>Sexual Abuse & Prevention Training:</b> All clients must participate in a mandatory training that assists with idenitfying inappropiate sexual behavior
                    and how to report it. <br /> <br />
                    <center>The Joint Commissions (TJC) 1-630-792-5800 <br /><br />
                        *note the numbers below can assist you if you are denied services, but still believe you need them <br /><br />
                        <b>Mental Hygiene Administration55 Wade Ave Baltimore, MD 21228410-402-8300 <br />
                            Baltimore Health Systems 201 E. Baltimore St. Suite 1340 Baltimore, MD 21201410-837-2647</b> <a href="www.BHSBaltimore.org">www.BHSBaltimore.org</a> </center>
                    <br /><br />
                    <b>PRP Service Overview: </b>PRP is a service that is similar to case management (mainly for adults) or behavior management/parenting
                    support (for minors). PRP Rehabilitation Counselors typically see their minor clients about 3 times per month and adult clients
                    approximately 6 times per month.</p> <br />


                <p className='w-750'><center><h4><b>Client Information Sheet</b></h4></center><br />
                    <b>Client Information</b></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name</span></td>

                        <td className='w-250'>
                            <span className='eleHeader'>DOB</span></td>

                        <td className='w-250'>
                            <span className='eleHeader'>SSN</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtName' name='txtName' className='add-only' /></td>

                        <td className='w-250'>
                            <input type='date' id='txtDateOfBirth' name='txtDateOfBirth' className='add-only' /></td>

                        <td className='w-250'>
                            <input type='text' id='txtSsn' name='txtSsn' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Address</span></td>

                        <td className='w-375'>
                            <span className='eleHeader'>Insurance</span></td>


                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAddress' name='txtAddress' className='add-only' /></td>

                        <td className='w-375'>
                            <input type='text' id='txtInsurance' name='txtInsurance' className='add-only' /></td>


                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City</span></td>

                        <td className='w-250'>
                            <span className='eleHeader'>State</span></td>

                        <td className='w-250'>
                            <span className='eleHeader'>Zip</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCity' name='txtCity' className='add-only' /></td>

                        <td className='w-250'>
                            <input type='text' id='txtState' name='txtState' className='add-only' /></td>

                        <td className='w-250'>
                            <input type='text' id='txtZip' name='txtZip' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone Number</span></td>

                        <td className='w-375'>
                            <span className='eleHeader'>E-Mail</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_1' name='txtAddress_1' className='add-only' /></td>

                        <td className='w-375'>
                            <input type='text' id='txtInsurance' name='txtInsurance' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>School/Work</span></td>

                        <td className='w-250'>
                            <span className='eleHeader'>Phone</span></td>

                        <td className='w-250'>
                            <span className='eleHeader'>Grade</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtSchoolWork' name='txtSchoolWork' className='add-only' /></td>

                        <td className='w-250'>
                            <input type='text' id='txtPhone' name='txtPhone' className='add-only' /></td>

                        <td className='w-250'>
                            <input type='text' id='txtGrade' name='txtGrade' className='add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'><b>Parent Guardian Information</b></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span></td>

                        <td className='w-375'>
                            <span className='eleHeader'>Relationship</span></td>


                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_1' name='txtName_1' className='add-only' /></td>

                        <td className='w-375'>
                            <input type='text' id='txtRelationship' name='txtRelationship' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Address</span></td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtAddress_2' name='txtAddress_2' className='add-only' /></td>

                    </tr>

                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City</span></td>

                        <td className='w-250'>
                            <span className='eleHeader'>State</span></td>

                        <td className='w-250'>
                            <span className='eleHeader'>Zip</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtCity_1' name='txtCity_1' className='add-only' /></td>

                        <td className='w-250'>
                            <input type='text' id='txtState_1' name='txtState_1' className='add-only' /></td>

                        <td className='w-250'>
                            <input type='text' id='txtZip_1' name='txtZip_1' className='add-only' /></td>
                    </tr>
                    
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Home Phone</span></td>

                        <td className='w-250'>
                            <span className='eleHeader'>Cell Phone</span></td>

                        <td className='w-250'>
                            <span className='eleHeader'>Email</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtHomePhone_1' name='txtHomePhone_1' className='add-only' /></td>

                        <td className='w-250'>
                            <input type='text' id='txtCellPhone_1' name='txtCellPhone_1' className='add-only' /></td>

                        <td className='w-250'>
                            <input type='text' id='txtEmail_1' name='txtEmail_1' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>Primary Care Physician Information</b></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span></td>

                        <td className='w-375'>
                            <span className='eleHeader'>Office Number</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_2' name='txtName_2' className='add-only' /></td>

                        <td className='w-375'>
                            <input type='text' id='txtOfficeNumber' name='txtOfficeNumber' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Address</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtAddress_3' name='txtAddress_3' className='add-only' /></td>

                    </tr>


                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>City</span></td>

                        <td className='w-250'>
                            <span className='eleHeader'>State</span></td>

                        <td className='w-250'>
                            <span className='eleHeader'>Zip</span></td>
                    </tr>
                    <tr>

                        <td className='w-250'>
                            <input type='text' id='txtCity_2' name='txtCity_2' className='add-only' /></td>

                        <td className='w-250'>
                            <input type='text' id='txtState_2' name='txtState_2' className='add-only' /></td>

                        <td className='w-250'>
                            <input type='text' id='txtZip_2' name='txtZip_2' className='add-only' /></td>
                    </tr>

                </table>

                <p className='w-750'><b>Emergency Contact Information</b></p>

                <table>

                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name</span></td>

                        <td className='w-375'>
                            <span className='eleHeader'>Relationship</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtName_3' name='txtName_3' className='add-only' /></td>

                        <td className='w-375'>
                            <input type='text' id='txtRelationShip_2' name='txtRelationShip_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Phone</span></td>

                        <td className='w-375'>
                            <span className='eleHeader'>Phone(2):</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhone_1' name='txtPhone_1' className='add-only' /></td>

                        <td className='w-375'>
                            <input type='text' id='txtPhone_2' name='txtPhone_2' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center><h4><b>New Client Orientation Process</b></h4></center>
                    <br />
                    By signing this form, I agree that I have received all of the information as listed above regarding the New Client
                    Orientation Process. <br /><br />

                    Prior to being admitted to the R.I.S.E Family Services, LLC program potential clients will meet with program staff to be
                    oriented to the program and review/sign consents. As part of this orientation process, clients will be given information
                    related to: </p>

                <ul>
                    <li>Description of Programs and Services</li>
                    <li>Client Bill of Rights</li>
                    <li>Hours of operation and after-hour/ crisis intervention services</li>
                    <li>Sexual Abuse & Prevention</li>
                    <li>Policies related to confidentialit</li>
                    <li>Complaint and grievance processes</li>
                    <li>Discharge Policies/Process</li>
                    <li>HIPPA</li>
                    <li>Primary Care Screening/ PCP Consent For</li>
                </ul>

                <p className='w-750'>Client will sign documentation stating that the above policies have been verbally explained and that the clients have
                    received a written copy of each form. <br /><br />

                    Client will also sign the Consent to Participate Form and Release oflnformation Form to include as appropriate the
                    individual's family members and others designated by the individual in the individual's service process. <br /><br />

                    Client will also be given a copy of the HIPPA Notice.
                    <br /><br />
                    If the individual is a minor who cannot consent to services; the appropriate consents will be obtained from the parent or
                    legal guardian. <br /><br />

                    If the individual agrees to consent to services but is unable or unwilling to give written consent, R.I.S.E Family Services,
                    LLC will: </p>

                <ol>
                    <li>Document the reasons why the individual cannot give written consent.</li>
                    <li>Verify the individual's verbal consent to services.</li>
                    <li>Periodically attempt to obtain written consent and document such efforts.</li>
                </ol>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Client/Parent/Guardian Signature</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Staff Signature</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>

                <p className='w-750'><center><h4><b>Client Bill of Rights</b></h4></center></p>

                <ul>
                    <li>Clients at R.I.S.E Family Services LLC have the following rights:</li>
                    <li>To receive compassionate, considerate, competent, respectful care in a way that recognizes their dignity and individuality.</li>
                    <li>To receive positive recognition, to be treated with warmth and caring, and to be spoken to and treated in an age appropriate manner.</li>
                    <li>To the most appropriate care and treatment available in the least restrictive environment, regardless of sex, religion, color, national origin, source of payment for care, or natures of severity of disabling condition if you meet the admission criteria.</li>
                    <li>To explanations, regarding clinical fees prior to admission.</li>
                    <li>To know the name, title, and role of qualified professionals on your team, who are credentialed and/or trained to provide the perceived care, treatment, and services for which they are responsible.</li>
                    <li>To obtain information regarding the nature of your condition, care, procedures and treatment, you will receive along with possible unanticipated outcomes, and discharge plans, in a language you understand.</li>
                    <li>To discuss with the treatment team any aspect of care or treatment and to actively participate in the planning of care and treatment.</li>
                    <li>To have your medical records read only by individuals directly involved in your treatment, individuals you have given written permission to view your records, by court order requiring the release of information or for disclosure of suicidal or homicidal thoughts in order to maintain your safety.</li>
                    <li>To receive an education about your diagnosis, treatment, and aftercare/discharge plan.</li>
                    <li>To be free from any kind of abuse at R.I.S.E Family Services LLC, including mental, physical, sexual, and corporate.</li>
                    <li>To request to leave R.I.S.E Family Services LLC prior to the termination of treatment and to be referred to another agency in the community as applicable.</li>
                    <li>To receive a copy of the R.I.S.E Family Services LLC "Client Rights" upon admission, in a language you understand.</li>
                </ul>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature:</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>

                <p className='w-750'><center><h4><b>BENEFITS/ENTITLEMENTS</b></h4></center>
                    The purpose of this form is to determine what benefits you are receiving, in addition to helping you learn more about benefits that you may be entitled to.
                    This information is protected under R.I.S.EFamily Services confidentiality policies and procedures.</p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Client Name</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtClientName' name='txtClientName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDate_1' name='txtDate_1' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>A. Check the benefits/ entitlements the client has:</b></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'><center><b>ENTITLEMENT/ BENEFIT</b><br />&nbsp;</center></span></td>
                        <td className='w-250'>
                            <span className='eleHeader'><center><b>RECEIVING (YES OR NO)</b><br />&nbsp;</center></span></td>
                        <td className='w-250'>
                            <span className='eleHeader'><center><b>SUPPORT NEED WITH ENTITLEMENT/ BENEFIT?</b></center></span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Food Supplement Program <b>(FSP)</b></td>
                        <td className='w-250'>
                            &nbsp;&nbsp;&nbsp;&nbsp;<input type='radio' id='rbFoodSupplementProgram_Yes' name='rbFoodSupplementProgram' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbFoodSupplementProgram_No' name='rbFoodSupplementProgram' className='add-only' value='No' /> No
                            <br />Amount$&nbsp;<input type='text' id='txtFoodSupplementProgram' name='txtFoodSupplementProgram' className='add-only w-80 custom-add-only' /></td>
                        <td className='w-250'>
                            <center><input type='radio' id='rbSupportNeedWith_Yes' name='rbSupportNeedWith' className='add-only' value='Yes' /> Yes &nbsp;
                                <input type='radio' id='rbSupportNeedWith_No' name='rbSupportNeedWith' className='add-only' value='No' /> No</center> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Medical Assistance<b>(MA)</b></td>
                        <td className='w-250'>
                            &nbsp;&nbsp;&nbsp;&nbsp;<input type='radio' id='rbMedicalAssistance_Yes' name='rbMedicalAssistance' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbMedicalAssistance_No' name='rbMedicalAssistance' className='add-only' value='No' /> No
                            <br />Amount$&nbsp;<input type='text' id='txtMedicalAssistance' name='txtMedicalAssistance' className='add-only w-80 custom-add-only' /></td>
                        <td className='w-250'>
                            <center><input type='radio' id='rbSupportNeedWith1_Yes' name='rbSupportNeedWith1' className='add-only' value='Yes' /> Yes &nbsp;
                                <input type='radio' id='rbSupportNeedWith1_No' name='rbSupportNeedWith1' className='add-only' value='No' /> No</center> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Maryland Children's Health Program <b>(MCHP)</b></td>
                        <td className='w-250'>
                            &nbsp;&nbsp;&nbsp;&nbsp;<input type='radio' id='rbMarylandChildrenHealthProgram_Yes' name='rbMarylandChildrenHealthProgram' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbMarylandChildrenHealthProgram_No' name='rbMarylandChildrenHealthProgram' className='add-only' value='No' /> No
                            <br />Amount$&nbsp;<input type='text' id='txtMarylandChildrenHealthProgram' name='txtMarylandChildrenHealthProgram' className='add-only w-80 custom-add-only' /></td>
                        <td className='w-250'>
                            <center><input type='radio' id='rbSupportNeedWith2_Yes' name='rbSupportNeedWith2' className='add-only' value='Yes' /> Yes &nbsp;
                                <input type='radio' id='rbSupportNeedWith2_No' name='rbSupportNeedWith2' className='add-only' value='No' /> No</center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Maryland Energy Assistance Program<b>(MEAP)</b></td>
                        <td className='w-250'>
                            &nbsp;&nbsp;&nbsp;&nbsp;<input type='radio' id='rbMarylandEnergyAssistanceProgram_Yes' name='rbMarylandEnergyAssistanceProgram' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbMarylandEnergyAssistanceProgram_No' name='rbMarylandEnergyAssistanceProgram' className='add-only' value='No' /> No
                            <br />Amount$&nbsp;<input type='text' id='txtMarylandEnergyAssistanceProgram' name='txtMarylandEnergyAssistanceProgram' className='add-only w-80 custom-add-only' /></td>
                        <td className='w-250'>
                            <center><input type='radio' id='rbSupportNeedWith3_Yes' name='rbSupportNeedWith3' className='add-only' value='Yes' /> Yes &nbsp;
                                <input type='radio' id='rbSupportNeedWith3_No' name='rbSupportNeedWith3' className='add-only' value='No' /> No</center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Social Security <b>(SS)</b></td>
                        <td className='w-250'>
                            &nbsp;&nbsp;&nbsp;&nbsp;<input type='radio' id='rbSocialSecurity_Yes' name='rbSocialSecurity' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbSocialSecurity_No' name='rbSocialSecurity' className='add-only' value='No' /> No
                            <br />Amount$&nbsp;<input type='text' id='txtSocialSecurity' name='txtSocialSecurity' className='add-only w-80 custom-add-only' /></td>
                        <td className='w-250'>
                            <center><input type='radio' id='rbSupportNeedWith4_Yes' name='rbSupportNeedWith4' className='add-only' value='Yes' /> Yes &nbsp;
                                <input type='radio' id='rbSupportNeedWith4_No' name='rbSupportNeedWith4' className='add-only' value='No' /> No</center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Temporary Cash Assistance <b>(TCA)</b></td>
                        <td className='w-250'>
                            &nbsp;&nbsp;&nbsp;&nbsp;<input type='radio' id='rbTemporaryCashAssistance_Yes' name='rbTemporaryCashAssistance' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbTemporaryCashAssistance_No' name='rbTemporaryCashAssistance' className='add-only' value='No' /> No
                            <br />Amount$&nbsp;<input type='text' id='txtTemporaryCashAssistance' name='txtTemporaryCashAssistance' className='add-only w-80 custom-add-only' /></td>
                        <td className='w-250'>
                            <center><input type='radio' id='rbSupportNeedWith5_Yes' name='rbSupportNeedWith5' className='add-only' value='Yes' /> Yes &nbsp;
                                <input type='radio' id='rbSupportNeedWith5_No' name='rbSupportNeedWith5' className='add-only' value='No' /> No</center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Temporary Disability Assistance Program <b>(TDAP)</b></td>
                        <td className='w-250'>
                            &nbsp;&nbsp;&nbsp;&nbsp;<input type='radio' id='rbTemporaryDisabilityAssistanceProgram_Yes' name='rbTemporaryDisabilityAssistanceProgram' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbTemporaryDisabilityAssistanceProgram_No' name='rbTemporaryDisabilityAssistanceProgram' className='add-only' value='No' /> No
                            <br />Amount$&nbsp;<input type='text' id='txtTemporaryDisabilityAssistanceProgram' name='txtTemporaryDisabilityAssistanceProgram' className='add-only w-80 custom-add-only' /></td>
                        <td className='w-250'>
                            <center><input type='radio' id='rbSupportNeedWith6_Yes' name='rbSupportNeedWith6' className='add-only' value='Yes' /> Yes &nbsp;
                                <input type='radio' id='rbSupportNeedWith6_No' name='rbSupportNeedWith6' className='add-only' value='No' /> No</center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Unemployment Insurance</td>
                        <td className='w-250'>
                            &nbsp;&nbsp;&nbsp;&nbsp;<input type='radio' id='rbUnemploymentInsurance_Yes' name='rbUnemploymentInsurance' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbUnemploymentInsurance_No' name='rbUnemploymentInsurance' className='add-only' value='No' /> No
                            <br />Amount$&nbsp;<input type='text' id='txtUnemploymentInsurance' name='txtUnemploymentInsurance' className='add-only w-80 custom-add-only' /></td>
                        <td className='w-250'>
                            <center><input type='radio' id='rbSupportNeedWith7_Yes' name='rbSupportNeedWith7' className='add-only' value='Yes' /> Yes &nbsp;
                                <input type='radio' id='rbSupportNeedWith7_No' name='rbSupportNeedWith7' className='add-only' value='No' /> No</center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Maryland Weatherization Assistance Program </td>
                        <td className='w-250'>
                            &nbsp;&nbsp;&nbsp;&nbsp;<input type='radio' id='rbMarylandWeatherizationAssistanceProgram_Yes' name='rbMarylandWeatherizationAssistanceProgram' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbMarylandWeatherizationAssistanceProgram_No' name='rbMarylandWeatherizationAssistanceProgram' className='add-only' value='No' /> No
                            <br />Amount$&nbsp;<input type='text' id='txtMarylandWeatherizationAssistanceProgram' name='txtMarylandWeatherizationAssistanceProgram' className='add-only w-80 custom-add-only' /></td>
                        <td className='w-250'>
                            <center><input type='radio' id='rbSupportNeedWith8_Yes' name='rbSupportNeedWith8' className='add-only' value='Yes' /> Yes &nbsp;
                                <input type='radio' id='rbSupportNeedWith8_No' name='rbSupportNeedWith8' className='add-only' value='No' /> No</center></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            Maryland Special Supplemental
                            Nutrition Program for Women, Infants, and Children
                            <b>(WIC)</b></td>
                        <td className='w-250'>
                            &nbsp;&nbsp;&nbsp;&nbsp;<input type='radio' id='rbMarylandSpecialSupplemental_Yes' name='rbMarylandSpecialSupplemental' className='add-only' value='Yes' /> Yes &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <input type='radio' id='rbMarylandSpecialSupplemental_No' name='rbMarylandSpecialSupplemental' className='add-only' value='No' /> No
                            <br />Amount$&nbsp;<input type='text' id='txt MarylandSpecialSupplemental' name='txtMarylandSpecialSupplemental' className='add-only w-80 custom-add-only' /></td>
                        <td className='w-250'>
                            <center><input type='radio' id='rbSupportNeedWith9_Yes' name='rbSupportNeedWith9' className='add-only' value='Yes' /> Yes &nbsp;
                                <input type='radio' id='rbSupportNeedWith9_No' name='rbSupportNeedWith9' className='add-only' value='No' /> No</center></td>
                    </tr>
                </table>

                <p className='w-750'>Staff Reviewing Form:&nbsp;<input type='text' id='txtStaffReviewing' name='txtStaffReviewing' className='add-only w-650 custom-add-only' /></p>


                <p className='w-750'><b>B. List benefits/ entitlements the client does not have for which he/she may be eligible and the timeframe for assisting the client or parent/guardian in applying for such:</b></p>


                <table>
                    <tr>
                        <td className='w-450'><span className='eleHeader'>Entitlement/ Benefit <br />&nbsp;</span></td>
                        <td className='w-150'><span className='eleHeader'>Receiving (yes or no)</span></td>
                        <td className='w-150'><span className='eleHeader'>Date Support Offered:</span></td>
                    </tr>
                    <tr>
                        <td className='w-450'><input type='text' id='txtEntitlementBenefit_1' name='txtEntitlementBenefit_1' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtReceiving_1' name='txtReceiving_1' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateSupportOffered_1' name='txtDateSupportOffered_1' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-450'><input type='text' id='txtEntitlementBenefit_2' name='txtEntitlementBenefit_2' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtReceiving_2' name='txtReceiving_2' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateSupportOffered_2' name='txtDateSupportOffered_2' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-450'><input type='text' id='txtEntitlementBenefit_3' name='txtEntitlementBenefit_3' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtReceiving_3' name='txtReceiving_3' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateSupportOffered_3' name='txtDateSupportOffered_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-450'><input type='text' id='txtEntitlementBenefit_4' name='txtEntitlementBenefit_4' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtReceiving_4' name='txtReceiving_4' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateSupportOffered_4' name='txtDateSupportOffered_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-450'><input type='text' id='txtEntitlementBenefit_5' name='txtEntitlementBenefit_5' className='add-only' /></td>
                        <td className='w-150'><input type='text' id='txtReceiving_5' name='txtReceiving_5' className='add-only' /></td>
                        <td className='w-150'><input type='date' id='txtDateSupportOffered_5' name='txtDateSupportOffered_5' className='add-only' /></td>
                    </tr>

                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Staff Signature and Title</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table><br />


                <p className='w-750'><h4><b>Entitlements Follow-Up</b></h4>
                    <b>A. Describe the outcome of entitlement application from "B" above, include dates of determinations:</b></p>


                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Entitlement/ Benefit</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Outcome of Support Offered:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtEntitlementBenefit_6' name='txtEntitlementBenefit_6' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtOutComeOfSupportOffered_1' name='txtOutComeOfSupportOffered_1' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtEntitlementBenefit_7' name='txtEntitlementBenefit_7' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtOutComeOfSupportOffered_2' name='txtOutComeOfSupportOffered_2' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtEntitlementBenefit_8' name='txtEntitlementBenefit_8' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtOutComeOfSupportOffered_3' name='txtOutComeOfSupportOffered_3' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtEntitlementBenefit_9' name='txtEntitlementBenefit_9' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtOutComeOfSupportOffered_4' name='txtOutComeOfSupportOffered_4' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtEntitlementBenefit_10' name='txtEntitlementBenefit_10' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtOutComeOfSupportOffered_5' name='txtOutComeOfSupportOffered_5' className='add-only' /></td>

                    </tr>

                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Staff Signature and Title</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>

                <p className='w-750'>
                    <center><h4><b>Consent for Treatment</b></h4></center></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Client</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtClient_1' name='txtClient_1' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDate_2' name='txtDate_2' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>1. I have reviewed and understand the services provided by R.I.S.E FamilyServices. <br /><br />
                    2. I understand that I may terminate part or all my services at anytime <br /><br />
                    3. I understand that the information in my medical record is confidential and protected by Federal and State law and
                    may only be disclosed with my permission (which may be withdrawn at any time), with the followingexceptions:</p>
                <ul>
                    <li>if I am an imminent threat to myself orothers;</li>
                    <li>a medical or psychiatricemergency;</li>
                    <li>when mandated by law, including if I report that I have abused or neglected a child or been a victim ofsuch;</li>
                    <li>to payers of mytreatment</li>
                    <li>to bodies licensing and accrediting R.I.S.E Family Services;and</li>
                    <li>to other Medicaidproviders</li>
                </ul>
                <p className='w-750'>4. If the client cannot or will not sign the form, but gives verbal consent, describe why there is no written consent and
                    the frequency of attempting to get written consent in the future: </p>

                <table>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'>Client/Parent/Guardian name</td>
                        <td className='small w-250'>Client/Parent/GuardianSignature</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-250'>StaffName </td>
                        <td className='small w-250'>Staff Signature </td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>

                <p className='w-750'>*All clients will receive electronic alerts to notify of all upcoming appointments. Please initial here as your agreement to
                    receiving electronic alerts (Data rates may apply). *<br />
                    Client Initials:<input type='text' id='txtClientInitials' name='txtClientInitials' className='add-only w-600 custom-add-only' /></p>


                <p className='w-750'><center><h4><b>HIPAA Notice of Privacy Practices Statement</b></h4></center>
                    <br />
                    <b>Notice of Information Practices and Privacy Statement in addition to R.I.S.E Family Services, LLC Privacy Practices.</b><br /><br />

                    <b>How We Collect Information About You:</b> R.I.S.EFamily Services and its employees and volunteers collect data through a variety of means including but not necessarily limited to letters, phone calls, emails, voice mails, and from the submission of
                    applications that is either required by law, or necessary to process applications or other requests for assistance through our organization. <br /><br />

                    <b>What We Do Not Do with Your Information:</b> Information about your financial situation and medical conditions and care that you provide to us in writing, via email, on the phone (including information left on voice mails),
                    contained in or attached to applications, or directly or indirectly given to us, is held in strictest confidence. <br /><br />

                    We do not give out, exchange, barter, rent, sell, lend, or disseminate any information about applicants or clients who apply for or actually receive our services that is considered Client confidential, is restricted by law,
                    or has been specifically restricted by a patient/client in a signed HIPAA consent form.
                    <br /><br />

                    <b>How We Do Use Your Information:</b> Information is only used as is reasonably necessary to provide you with health or counseling services which may require communication between R.I.S.EFamily Services. and health care providers, medical product or service providers, pharmacies, insurance companies, and other providers necessary to: verify your medical information is accurate; determine the type of medical supplies or any health care services you need including, but not limited to;
                    or to obtain or purchase any type of medical supplies, devices, medications and or insurance. <br /><br />

                    If you apply or attempt to apply to receive assistance through us and provide information with the intent or purpose of fraud or that
                    results in either an actual crime of fraud for any reason including willful or unwilful acts of negligence whether intended or not, or in any way demonstrates or indicates attempted fraud, your non-medical information can be given to legal authorities including police,
                    investigators, courts, and/or attorneys or other legal professionals, as well as any other information as permitted by law. <br /><br />

                    <b>I have read the above HIPPA privacy practices and I understand the limits of confidentiality, privacy policies, my rights and their meanings and ramifications.</b></p>

                <p className='w-750'><center><h4><b>Advance Directive for Mental Health Treatment</b></h4></center><br />
                    <b>(FOR ADULTS ONLY)</b> <br /><br />
                    Maryland state law gives the right to anyone 18 years of age and older to be involved in decisions about their mental health treatment. Maryland law states that you as a client/consumer have the right to make decisions in advance, including mental health treatment decisions,
                    through a process called an <b>Advance Directive</b>(sometimes referred to as Advance Instructions). <br /><br />

                    An <b>Advance Directiveis</b> a legal document that permits competent individuals to make choices about various medical treatments they might want or not want if, at some future time, they lose the capacity to make or communicate treatment decisions. Such a directive affords the individual an
                    opportunity to discuss, plan, and in many cases determine aspects of mental health treatment and care. <br /><br />

                    Advance Directives are optional for each adult client, based upon your personal preference, and are not a mandatory component of your care. R.I.S.E Family Services is equipped to provide additional information to you in regards to completing an Advance Directive. <br /><br />

                    <input type='checkbox' id='cbHaveBeenInformed' name='cbHaveBeenInformed' className='add-only' value='1' /><b>YES</b> I have been informed of my rights to complete an Advance Directive as part
                    of my mental health treatment with R.I.S.E Family Services. <br /><br />

                    Please check or initial one box below regarding an Advance Directive <hr />
                    <input type='checkbox' id='cbWouldLikeToComplete' name='cbWouldLikeToComplete' className='add-only' value='2' />I would like to complete an Advance Directive as part of my mental health treatment with R.I.S.E
                    Family Services <br />

                    <input type='checkbox' id='cbAmNotInterestedCompleting' name='cbAmNotInterestedCompleting' className='add-only' value='3' />I am not interested in completing an Advance Directive with R.I.S.E Family Services at this time. <b>I understand that I may exercise my right at any time to
                        request/complete an Advance Directive as part of my ongoing treatment with R.I.S.E Family Services</b>
                </p>

                <p className='w-750'><center><b>TELEHEALTH CONSENT FORM</b></center>
                    I,&nbsp;<input type='text' id='txtTelehealthConsent_1' name='txtTelehealthConsent_1' className='add-only w-100 custom-add-only' />&nbsp;(Client) hereby consent to engage in Telehealth with&nbsp;<input type='text' id='txtTelehealthConsent_2' name='txtTelehealthConsent_2' className='add-only w-100 custom-add-only' />&nbsp;(Therapist). I understand that Telehealth is a mode of delivering health care services, including psychotherapy, via communication technologies (e.g. Internet or phone) to facilitate diagnosis,
                    consultation, treatment, education, care management,
                    and self-management of a patient's health care. <br /><br />
                    <b>By signing this form, I understand and agree to the following:</b><br />
                    1. I have a right to confidentiality regarding my treatment and related communications via Telehealth under the same laws that protect the confidentiality of my treatment information during in-person psychotherapy. The same mandatory and permissive exceptions to confidentiality outlined in the [Informed Consent Form or Statement of Disclosures]
                    I received from my therapist also apply to my Telehealth services. <br /><br />

                    2. I understand that there are risks associated with participating in Telehealth including, butnot limited to, the possibility, despite reasonable efforts and safeguards on the part of mytherapist, that my psychotherapy sessions and transmission of my treatment informationcould be disrupted or distorted by technical failures and/or interrupted or accessed byunauthorized persons, and that the electronic storage of my treatment information
                    couldbe accessed by unauthorized persons. <br /><br />

                    3. I understand that miscommunication between myself and my therapist may occur viaTelehealth. <br /><br />

                    4. I understand that there is a risk of being overheard by persons near me and that I amresponsible for using a location that is private and free from distractions or intrusions. <br /><br />

                    5. I understand that at the beginning of each Telehealth session my therapist is required toverify my full name and current location. <br /><br />

                    6. I understand that in some instances Telehealth may not be as effective or provide the sameresults as in-person therapy. I understand that if my therapist believes I would be betterserved by in-person therapy, my therapist will discuss this with me and refer me to in-person services as needed. If such services are not possible because of distance orhardship,
                    I will be referred to other therapists who can provide such services. <br /><br />

                    7. I understand that while Telehealth has been found to be effective in treating a wide rangeof mental and emotional issues, there is no guarantee that Telehealth is effective for allindividuals. Therefore, I understand that while I may benefit from Telehealth,
                    results cannotbe guaranteed or assured. <br />br

                    8.	I understand that some Telehealth platforms allow for video or audio recordings and thatneither I nor my therapist may record the sessions without the other party's writtenpermission. <br /><br />

                    9.	I have discussed the fees charged for Telehealth with my therapist and agree to them [or forinsurance Clients: I have discussed with my therapist and agree that my therapist will billmy insurance plan for Telehealth and that I will be billed for any portion that is the patient'sresponsibility (e.g. co-payments)], and I have been provided with this information in the[Infonned Consent Form or Name of Payment Agreement Form].
                    <br /><br />

                    10.	I understand that my therapist will make reasonable efforts to ascertain and provide mewith emergency resources in my geographic area. I further understand that my therapistmay not be able to assist me in an emergency situation. If I require emergency care, !understand that I may call 911 or proceed to the nearest hospital emergency room forimmediate assistance.
                    <br /><br />

                    I have read and understand the information provided above, have discussed it with mytherapist, and understand that I have the right to have all my questions regarding thisinformation answered to my satisfaction. <br /><br />

                    [For conjoint or family therapy, Clients may sign individual consent forms or sign the sameform.]</p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Client's Printed Name</td>
                        <td className='small w-375'>Client's Signature Date</td>
                    </tr>
                </table>

                <p className='w-750'><center><h4><b>Verbal Consent Obtained</b></h4></center>
                    Therapist reviewed Telehealth Consent Form with Patient, Client understands and agrees tothe above advisements, and Client has verbally consented to
                    receiving psychotherapy servicesfrom Therapist via Telehealth.</p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp; </td>
                        <td className='signature w-250'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Therapist's Signature</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>

                <p className='w-750'><center><b>PRIMARY CARE SCREEENING FORM</b></center></p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Client Name:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtClientName_1' name='txtClientName_1' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDate_3' name='txtDate_3' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>DOB</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of Last Physical:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtDateOfBirth_1' name='txtDateOfBirth_1' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDateOfLastPhysical' name='txtDateOfLastPhysical' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><b>Please check an option:</b><br />
                    <input type='checkbox' id='cbPleaseCheckAnOption_1' name='cbPleaseCheckAnOption_1' className='add-only' value='1' /> I don't have a primary care physician (PCP) and I agree to contact: PG Health Department at 301-883- 7879 and notify them that I do not have a primary care physician and need to secure one.
                    <br />
                    <input type='checkbox' id='cbPleaseCheckAnOption_2' name='cbPleaseCheckAnOption_2' className='add-only' value='2' /> I have a PCP but do not want R.I.S.E FAMILY SERVICES to contact my doctor
                    <br />
                    <input type='checkbox' id='cbPleaseCheckAnOption_3' name='cbPleaseCheckAnOption_3' className='add-only' value='3' /> I have a PCP and I give permission to send/ receive information pertaining to my medical history as well as treatment at R.I.S.E FAMILY SERVICES. Below is their contact information:</p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Doctor's Name:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Address</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtDoctorName' name='txtDoctorName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtAddress_4' name='txtAddress_4' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Telephone:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Fax:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtTelephone' name='txtTelephone' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtFax' name='txtFax' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>
                    CLIENT SIGNATURE:&nbsp;<input type='text' id='txtClientSignature' name='txtClientSignature' className='add-only w-500 custom-add-only' /> <br />
                    The following is supplied for you information regarding the above client.</p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Beginning date of treatment: </span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Diagnosis:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtBeginningDateTreatment' name='txtBeginningDateTreatment' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtDiagnosis' name='txtDiagnosis' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Services currently receiving</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtServicesCurrentlyReceiving' name='txtServicesCurrentlyReceiving' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'><center>If you have any questions about this client's treatment at R.I.S.E FAMILY SERVICES, please feel free to contact our office at 301-778-8835 <br />
                    We would also appreciate receiving a summary of the client's medical history and any medications currently being prescribed.</center>  <br /><br />
                    <center><b>Minor child <br />
                        MEDICAL AUTHORIZATION AND GENERAL RELEASE OF LIABILITY</b></center> <br /><br />

                    <b>KNOWN TO ALL BY THESE PRESENT,THAT I,</b>&nbsp;<input type='text' id='txtMedicalAuthorization' name='txtMedicalAuthorization' className='add-only w-100 custom-add-only' />&nbsp;, the undersigned authorized parent/legal guardian do hereby execute this Medical Authorization and General Release of Liability with the intention that,&nbsp;<input type='text' id='txtMedicalAuthorization_1' name='txtMedicalAuthorization_1' className='add-only w-100 custom-add-only' />&nbsp;, the minor child in my legal care and custody, whether my natural or adopted child, stepchild, grandchild, ward, or any other such child in my legal care and custody, ("Minor Child") may participate in all R.I.S.E Family Services LLC
                    sponsored treatment, events, and activities ("activities"). <br /><br />

                    I acknowledge that in the event of injury or illness to the minor child, whether or not related to said activities, R.I.S.E Family Services LLC personnel shall
                    make reasonable efforts to first obtain prior authorization from the Minor Child's parent/legal guardian for any medical treatment which may be required,
                    but in the event that such prior authorization cannot be obtained, I expressly authorize R.I.S.E Family Services LLC personnel to exercise reasonable judgment
                    in taking whatever steps necessary to engage medical personnel for treatment of the Minor Child, including but not limited to securing transport and if needed
                    admitting the Minor Child to any hospital or treatment facility and to five permission for any diagnosis, treatment, and admission on my behalf for the care
                    and benefit of the Minor Child as may be required for treatment of any such injury or illness. <br />br

                    I understand that by signing my name below, I likewise am expressly releasing R.I.S.E Family Services LLC, and its officers, agents, employees, interns, or any
                    students acting as employees, from any and all liability for injury, illness, or damage to or suffered by the Minor Child arising from or as a direct of indirect
                    result of the Minor Child's participation in said activities and agree to hold harmless the officers, agents, employees, interns, or any students acting as employees
                    of R.I.S.E Family Services LLC from any and all liability for any such injury incurred and/or damages resulting therefrom. <br /><br />

                    I further understand that in connection with said activities, the Minor Child may travel in private automobiles, buses, other vehicles, or by means of transportation owned, leased, or borrowed by R.I.S.E Family Services LLC, or may otherwise travel on public transportation under the care and supervision of R.I.S.E Family Services LLC personnel, and I understand
                    that this release of liability to which I am signing, shall apply to injury or damages sustained or arising from or resulting directly or indirectly from such travel. Likewise, if I am accompanying the Minor Child in said activity or activities, or travel to or from said activities, I also understand that this release of liability shall also apply to myself as well as the
                    Minor Child. <br /><br />

                    I also understand that such activities and/or travel may occur in whole or in part outside of the State of Maryland and agree that the Minor Child may participate in such activities and/or travel outside of the State.
                    <br /><br />

                    I acknowledge that I am a competent adult of the age of eighteen (18) years of age, that I have read the foregoing Medical Authorization and General Release of Liability, that I understand its content, that I am authorized to make this authorization and release, and that I am signing the same voluntarily.
                    <br /><br />

                    This authorization and release shall be valid and in full force and effect for any period of time in which the Minor Child is participating or involved in any activities or programs of R.I.S.E Family Services LLC. This authorization and release likewise shall remain valid and be in full force and effect until such time as it may be revoked by me in writing.
                    <br /><br />

                    IN WITNESS WHERE OF, I have signed and acknowledged this authorization and release this&nbsp;<input type='text' id='txtInWitnessWhere' name='txtInWitnessWhere' className='add-only w-100 custom-add-only' />&nbsp;day of&nbsp;<input type='text' id='txtInWitnessWhere_1' name='txtInWitnessWhere_1' className='add-only w-100 custom-add-only' />&nbsp;, 20&nbsp;<input type='text' id='txtInWitnessWhere_2' name='txtInWitnessWhere_2' className='add-only w-100 custom-add-only' />
                </p>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Parent/Legal Guardian Signature</td>
                        <td className='small w-375'>Witness Signature</td>
                    </tr>
                </table><br />

                <p className='w-750'><center><h4><b>R.I.S.E Family Services Discharge/Termination Policy</b></h4></center>
                    R.I.S.E Family Services, LLC strives to provide its services to ensure that the client will receive optimal results in the therapeutic process. Termination or discharge from R.I.S.E Family
                    Services is the goal upon initial services as the client begins to master set tasks and reach outlined goals. R.I.S.E Family Services reserves the right to terminate or discharge a client based on,
                    but not limited to the following criteria:</p>

                <ul>
                    <li>The client has satisfactorily mastered tasks and completed set goals</li>
                    <li>The client has not satisfactorily mastered tasks and completed goals based on reasonable timelines, and support and efforts provided by the staff of R.I.S.E Family Services</li>
                    <li>The client has moved to a non-serviceable location (i.e., another region, State, or country).</li>
                    <li>The client's behavior has become a risk to the safety of any R.I.S.E Family Services staff.</li>
                    <li>The client is not compliant with therapy/and or medication management.</li>
                </ul>

                <p className='w-750'>I&nbsp;<input type='text' id='txtHaveReadAndAcknowledge' name='txtHaveReadAndAcknowledge' className='add-only w-100 custom-add-only' />&nbsp;have read and acknowledge my understanding of the Discharge/ Termination policy and agree to its terms.</p>

                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Printed Name of Client</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Witness</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPrintedNameOfClient' name='txtPrintedNameOfClient' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtWitness' name='txtWitness' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>Signature</td>
                        <td className='small w-375'>Date</td>
                    </tr>
                </table>

                <p className='w-750'><center><h4><b>PATIENT	HEALTH QUESTIONNAIRE-9 (PHQ-9)</b></h4></center></p>

                <table>
                    <tr>
                        <td className='w-350'><span className='eleHeader'>Over the last 2 weeks, how often have you been bothered by any of the following problems?
                            <span className='small'><b>(Use check to indicate your answer)</b></span>
                        </span></td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>Not at all <b>(0)</b><br />&nbsp;</span></center></td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>Several Days <b>(1)</b><br />&nbsp;</span></center></td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>More Than Half The Days <b>(2)</b></span></center></td>
                        <td className='w-100'>
                            <center><span className='eleHeader'>Nearly Every Day <b>(3)</b></span></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>1. Little interest or pleasure in doing things</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittleInterestOrPleasure_1' name='rbLittleInterestOrPleasure' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittleInterestOrPleasure_2' name='rbLittleInterestOrPleasure' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittleInterestOrPleasure_3' name='rbLittleInterestOrPleasure' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbLittleInterestOrPleasure_4' name='rbLittleInterestOrPleasure' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>2 .Feeling down, depressed, or hopeless</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFellingDownDepressed_1' name='rbFellingDownDepressed' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFellingDownDepressed_2' name='rbFellingDownDepressed' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFellingDownDepressed_3' name='rbFellingDownDepressed' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFellingDownDepressed_4' name='rbFellingDownDepressed' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>3.Trouble falling or staying asleep, or sleeping too much</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTroubleFallingOrStayingAsleep_1' name='rbTroubleFallingOrStayingAsleep' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTroubleFallingOrStayingAsleep_2' name='rbTroubleFallingOrStayingAsleep' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTroubleFallingOrStayingAsleep_3' name='rbTroubleFallingOrStayingAsleep' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTroubleFallingOrStayingAsleep_4' name='rbTroubleFallingOrStayingAsleep' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>4. Feeling tired or having little energy</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingTiredOrHavingLittleEnergy_1' name='rbFeelingTiredOrHavingLittleEnergy' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingTiredOrHavingLittleEnergy_2' name='rbFeelingTiredOrHavingLittleEnergy' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingTiredOrHavingLittleEnergy_3' name='rbFeelingTiredOrHavingLittleEnergy' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingTiredOrHavingLittleEnergy_4' name='rbFeelingTiredOrHavingLittleEnergy' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>5. Poor appetite or overeating</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPoorAppetiteOrOvereating_1' name='rbPoorAppetiteOrOvereating' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPoorAppetiteOrOvereating_2' name='rbPoorAppetiteOrOvereating' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPoorAppetiteOrOvereating_3' name='rbPoorAppetiteOrOvereating' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbPoorAppetiteOrOvereating_4' name='rbPoorAppetiteOrOvereating' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>6. Feeling bad about yourself - or that you are a failure or have let yourself or your family down</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingBadAboutYourselfThatYou_1' name='rbFeelingBadAboutYourselfThatYou' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingBadAboutYourselfThatYou_2' name='rbFeelingBadAboutYourselfThatYou' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingBadAboutYourselfThatYou_3' name='rbFeelingBadAboutYourselfThatYou' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbFeelingBadAboutYourselfThatYou_4' name='rbFeelingBadAboutYourselfThatYou' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>7. Trouble concentrating on things, such as reading the newspaper or watching television</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTroubleCocentratingOnThings_1' name='rbTroubleCocentratingOnThings' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTroubleCocentratingOnThings_2' name='rbTroubleCocentratingOnThings' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTroubleCocentratingOnThings_3' name='rbTroubleCocentratingOnThings' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbTroubleCocentratingOnThings_4' name='rbTroubleCocentratingOnThings' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>8. Moving or speaking so slowly that other people could have noticed? Or the opposite - being so fidgety or restless that you have been moving around a lot more than usual</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMovingOrSpeakingSoSlowlyThatOther_1' name='rbMovingOrSpeakingSoSlowlyThatOther' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMovingOrSpeakingSoSlowlyThatOther_2' name='rbMovingOrSpeakingSoSlowlyThatOther' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMovingOrSpeakingSoSlowlyThatOther_3' name='rbMovingOrSpeakingSoSlowlyThatOther' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbMovingOrSpeakingSoSlowlyThatOther_4' name='rbMovingOrSpeakingSoSlowlyThatOther' className='add-only' value='4' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>9. Thoughts that you would be better off dead or of hurting yourself in some way</td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbThoughtThatYouWouldBeBetterOffDead_1' name='rbThoughtThatYouWouldBeBetterOffDead' className='add-only' value='1' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbThoughtThatYouWouldBeBetterOffDead_2' name='rbThoughtThatYouWouldBeBetterOffDead' className='add-only' value='2' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbThoughtThatYouWouldBeBetterOffDead_3' name='rbThoughtThatYouWouldBeBetterOffDead' className='add-only' value='3' /></center></td>
                        <td className='w-100'>
                            <center><input type='radio' id='rbThoughtThatYouWouldBeBetterOffDead_4' name='rbThoughtThatYouWouldBeBetterOffDead' className='add-only' value='4' /></center></td>
                    </tr>

                    <tr>
                        <pre><td className='w-350'>                                                                             <b>For Office Coding</b></td></pre>
                        <td className='w-100'>
                            <center><input type='text' id='txtLastName' name='txtLastName' className='add-only w-50 custom-add-only' /></center></td>+
                        <td className='w-100'>
                            <center><input type='text' id='txtLastName' name='txtLastName' className='add-only w-50 custom-add-only' /></center></td>+
                        <td className='w-100'>
                            <center><input type='text' id='txtLastName' name='txtLastName' className='add-only w-50 custom-add-only' /></center></td>+
                        <td className='w-100'>
                            <center><input type='text' id='txtLastName' name='txtLastName' className='add-only w-50 custom-add-only' /></center></td>
                    </tr>
                    <tr>
                        <td className='w-350'>&nbsp;</td>
                        <td className='w-100'>
                            &nbsp;</td>
                        <td className='w-100'>
                            &nbsp;</td>
                        <td className='w-200'><b>=Total Score:</b>&nbsp;
                            <input type='text' id='txtTotalScore' name='txtTotalScore' className='add-only w-70 custom-add-only' /></td>

                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If you checked off any problems, how difficult have these problems made it for you to do your work, take care of things at home, or get along with other people?</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbIfYouCheckedOffAnyProblemsHowDifficultHave_1' name='rbIfYouCheckedOffAnyProblemsHowDifficultHave' className='add-only' value='1' /> Not Difficult at All
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbIfYouCheckedOffAnyProblemsHowDifficultHave_2' name='rbIfYouCheckedOffAnyProblemsHowDifficultHave' className='add-only' value='2' /> Somewhat Difficult
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbIfYouCheckedOffAnyProblemsHowDifficultHave_3' name='rbIfYouCheckedOffAnyProblemsHowDifficultHave' className='add-only' value='3' /> Very Difficult
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbIfYouCheckedOffAnyProblemsHowDifficultHave_4' name='rbIfYouCheckedOffAnyProblemsHowDifficultHave' className='add-only' value='4' /> Extremely Difficult
                        </td>
                    </tr>
                </table>

                <p className='w-750'><span className='eleHeader'>Are you currently receiving behavioral health Services from other provider?</span>
                    <input type='radio' id='rbAreYouCurrentlyReceivingBehavioralHealth_Yes' name='rbAreYouCurrentlyReceivingBehavioralHealth' className='add-only' value='Yes' /> Yes&nbsp;
                    <input type='radio' id='rbAreYouCurrentlyReceivingBehavioralHealth_No' name='rbAreYouCurrentlyReceivingBehavioralHealth' className='add-only' value='No' /> No</p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <b>If yes, Provide Information</b></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Company Name</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Of Last Visit</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtCompanyName' name='txtCompanyName' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDateLastVisit' name='txtDateLastVisit' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Number</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Provider Name</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtNumber' name='txtNumber' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtProviderName' name='txtProviderName' className='add-only' /></td>
                    </tr>
                </table>

                <p className='w-750'>Developed by Ors. Robert L. Spitzer, Janet B.W. Williams, Kurt Kroenke and colleagues, with an educational grant from Pfizer Inc. No permission required to reproduce, translate, display or distribute.</p>

                <p className='w-750'><center><h4><b>CANCELLATION POLICY</b></h4>
                    <b>**NO SHOW/LATE CANCELLATION ($100 CHARGE)** </b></center> <br /><br />

                    <b>CAN CELLA TIO NS AND MISSED APPOINTMENTS: </b>The client is expected to attend each scheduled
                    session on time. A cancelled or delayed appointment delays our work and can negatively impact other
                    clients. Since your appointments involve the reservation of time specifically for you, and out of respect for
                    your therapist and our other clients, a minimum of 24 hours' notice is required for rescheduling or canceling an
                    appointment. We appreciate more than 24-hour notice when possible, as we can then make that time available
                    to other clients. Therefore, if you should know before the required 24-hour notice that you will not be able to
                    attend our session, PLEASE call the office, or text the appointment reminder so that we have time to fill your
                    slot and can put another client in your space that may need it. The more time, the better for the therapist and
                    other clients who are in need. <br /><br />

                    A late cancel or no-show appointment hurts at least three people: you, your therapist, and another client who
                    could have potentially utilized your time slot. Therapy sessions are scheduled in advance and are a time
                    reserved exclusively for our clients. When a session is cancelled without adequate notice, we are unable to fill
                    this time slot by offering it to another current client, a client on the wait list, or a client with a clinical
                    emergency. <br /><br />

                    <b>WHEN THE NO SHOW/LATE CANCEL FEE IS WAIVED</b><br />
                    The only exception to this cancellation policy is in the event of a serious or contagious illness or emergency.
                    We offer one grace for these purposes every six months. Some examples of emergencies are car accidents,
                    deaths in the family or extreme illness. Work issues do not constitute emergencies. This cancellation policy
                    also applies even if missing the appointment was an unintentional act. In the event of prohibitive weather, we
                    can conduct the session on the phone or video (individual counseling). If both parties in a couple cannot attend,
                    consider having one come alone instead of cancelling altogether and wasting the slot. Phone or video sessions
                    are paid up-front in advance of the session. <br /><br />

                    <b>FREQUENT CAN CELLA TIO NS OR MISSED APPOINTMENT </b><br />
                    Frequent cancellations (3 or more in 6 months or 2 consecutive) and/or missed appointments (no show) will
                    result in the termination of treatment. If you have arranged with your therapist to have recurring appointments,
                    the next recurring appointment will stay in the calendar. Therefore, please call the office if you choose to
                    cancel that appointment to avoid a second No Show/Late Cancel charge of$100. A voice mail is sufficient as
                    they are date and time stamped. The recurring appointment will be removed after the second consecutive No
                    Show/Late Cancel <br /><br />

                    Although R.I.S.E Family Services may send you text or email reminders about upcoming appointments, this is
                    done as a courtesy and only if you consent to receive such communications by providing us with your email
                    address and cell number. It remains your sole responsibility to keep track of and timely attend all scheduled
                    therapy appointments, whether you receive the text or email reminder. It is your responsibility to inform the
                    office if your phone number or email has changed. After two (2) consecutive cancellations or no shows, you
                    will not be able to schedule another appointment and will be referred to another provider. <br /><br />

                    <b>FEES FOR NO-SHOWS & LATE CANCELLATIONS</b><br />
                    <b> No-Show Fees:</b>Anytime you fail to attend a scheduled appointment without giving appropriate prior notice of
                    cancellation. you will be charged $100 for the no show session. The credit card information or other payment
                    information you previously provided will be used to process this payment. By providing us with your credit card information or booking an appointment,
                    you consent to this policy. Multiple no-shows will result in the termination of therapy. <br /><br />

                    <b>Late Cancellation Fees:</b> Any session that is missed by canceling less than 24 hours in advance <b>will be charged a $100 fee.</b> You will be charged even if the cancellation is work related and even if you rescheduled the appointment. The credit card information you previously provided will be used to process this payment. By providing us with your credit card information or booking an appointment, you consent to this
                    policy. Repeated late cancellations (more than two) may result in the termination of therapy. Multiple no shows will result in the termination of therapy. <br /><br />

                    <b>You should note that insurance companies generally do not reimburse for missed appointments.</b> <br /><br />
                    <b>HOW 24-HOUR NOTICE WORKS</b><br />

                    A fee of <b>$100</b>will be charged when you miss or cancel an appointment without giving 24 <b>hours advanced notice.</b> This means that if an appointment is scheduled for 3:00 pm on a Tuesday, notice must be given by 3:00 pm on Monday <b>at the absolute latest. Note that if</b> your appointment is on a Monday, the cancellation needs to be provided no later than the prior Friday, by your appointment time, to be considered proper 24-hour notice.
                    You can cancel your appointment by calling the office or texting the office. <br /><br />

                    <b>WAIT TIME/GRACE PERIOD</b> <br />
                    Your wait time is kept to a minimum. Due to the length of time provided for each appointment, it is critical that you arrive on time for your appointments.
                    <b>If you are more than 10 minutes late to your appointment, we will have no choice but to reschedule your appointment and you will be responsible for the $100 fee
                        of a no show.</b> To avoid paying no show fees, we require at least twenty-four (24) hours' notice for all cancellations (as described above).
                    Both therapist and client have a grace period of 10 minutes. <br /><br />

                    <b>MEDICAID OR MEDICARE CLIENTS</b><br />
                    Please note that the fees described in this policy cannot be applied for clients with Medicaid insurance. Thus, clients with Medicaid insurance who have three or more late cancellations or missed sessions will be referred
                    to other providers should there be any indication that the pattern will continue.
                    <br /><br />

                    Medicaid or Medicare Clients: Please note that your therapist cannot charge you or your insurance for missed sessions or late cancellations.
                    This means that your appointment slot could have been filled with a client who paid; instead, your therapist will lose money or the opportunity to
                    schedule another client if you late cancel or do not show up. Because of this, three or more late cancellations for Medicaid or Medicare clients
                    within a six-month period or with respect to two consecutive sessions will result in immediate discharge and referral elsewhere. Clients who are unsure if they can commit to therapy weekly should seek services elsewhere. <br /><br />

                    Additionally, please understand that therapy should be viewed as any other important medical appointment would be viewed. While it is a time commitment,
                    this is for your personal betterment and consistency is key to achieve this. If the therapeutic relationship is terminated pursuant to this policy, your
                    case may be reopened at any time should you so choose. However, you may be placed on a waiting list if there are other
                    clients waiting to use your time slot. This is standard practice with most therapy agencies and private practice offices. <br /><br />

                    <b>THANK YOU</b> <br />
                    We value you as a client and hope to help you with your future endeavors; however, we can only accomplish this with your understanding of your obligations set
                    forth in this policy and consistency with treatment. Thank you for your understanding. Your therapist looks forward to
                    beginning this therapeutic journey alongside you!</p>
            </div>
        </form >
    )
}